export default __webpack_public_path__ + "static/media/email.f7e86575.svg";